import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

export default function StaticDataWarning() {
  const { t, i18n } = useTranslation('common');
  return (
    <div
      role="alert"
      key={i18n.language}
      className="w-full py-2.5 px-6 bg-amber-50 border-b border-amber-400 text-amber-800 text-sm font-medium text-center"
    >
      <Trans t={t} i18nKey="staticDataWarning" components={{ 1: <strong /> }} />
    </div>
  );
}
